<template lang="pug">

div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-img-max.u-mt-md
    AppLink(to="/culture" :alt="$t('culture')" )
      AppImg(:srcset="[{ srcset: '{CDN_URL}/careers/1@2x.webp 2x, {CDN_URL}/careers/1.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/careers/1@2x.png 2x, {CDN_URL}/careers/1.png 1x', type: 'image/png' }]" ratio="5:2" :alt="$t('culture')")

  section.u-mt-md
    h2.u-mb-sm {{$t('featuredPositions')}}
    Query(
      :query="require('~/graphql/Career.gql').Careers"
      :limit="4"
      :initialValue="careers"
      :moreButton="false"
      :variables="({ first, after }) => ({ first, after, isPublished: true, isArchived:false })"
      v-slot="{ items }"
    )
      CareersCard(v-for="career,idx in items" :key="idx" :data="career")
    section.u-mt-sm
      AppLink(to="/careers/opportunities" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

    //- Query.grid.is-tablet-4(
    //-   :query="require('~/graphql/Career.gql').Careers"
    //-   :limit="4"
    //-   :initialValue="careers"
    //-   :moreButton="false"
    //-   :variables="({ first, after }) => ({ first, after, isPublished: true, isArchived:false })"
    //-   v-slot="{ items }"
    //- )
    //-   AsymetricGrid(:items="items" ref="grid" v-slot="{ item, ratio }")
    //-     AppCard(:img="item.thumb ? [{ srcset: item.thumb, type: 'image/jpg', ratio }] : [{ srcset: '{CDN_URL}/default@2x.jpg 2x, {CDN_URL}/default.jpg 1x', type: 'image/jpg' }]" :ratio="ratio" :title="item.title" :excerpt="item.description" :url="`/careers/${item.slug}`" :meta="getBranchName(item)")


  //- AppSection(:img="[{ srcset: '{CDN_URL}/careers/1@2x.webp 2x, {CDN_URL}/careers/1.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/careers/1@2x.png 2x, {CDN_URL}/careers/1.png 1x', type: 'image/png' }]" ratio="5:3" :img-alt="$t('culture')" class="u-mt-md ")
  //-   h3 {{ $t('culture') }}
  //-   p {{ $t('cultureDesc') }}
  //-   .u-mt-xs
  //-     AppLink(to="/culture" :title="$t('knowMore')" class="button-link is-medium ") {{$t('knowMore')}}

  AppSection(:img="[{ srcset: '{CDN_URL}/careers/2@2x.webp 2x, {CDN_URL}/careers/2.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/careers/2@2x.png 2x, {CDN_URL}/careers/2.png 1x', type: 'image/png' }]" ratio="5:3" :img-alt="$t('baianaters')" class="u-mt-md is-reversed ")
    h3 {{ $t('baianaters') }}
    p {{ $t('baianatersDesc') }}
    .u-mt-xs
      AppLink(to="/teams" :title="$t('baianatersCta')" class="button-link ") {{$t('baianatersCta')}}

  section.u-mt-md
    AppTitle.u-mb-sm(:title="$t('values')" tag="h2")
    .grid.is-desktop-4
      .column.u-mb-sm(v-for="item in $t('valuesItems')")
        AppCardBox
          h4 {{ item.title }}
          p {{ item.desc }}
    AppLink(to="/culture/values" title="$t('valuesCta')" class="button-link " v-html="$t('valuesCta')")

  section.u-mt-md
    AppTitle.u-mb-sm(:title="$t('life')" tag="h2")

    .u-img-max.u-mb-sm
      AppImg(:srcset="[{ srcset: '{CDN_URL}/careers/3@2x.webp 2x, {CDN_URL}/careers/3.webp 1x', type: 'image/webp' }, { srcset: '{CDN_URL}/careers/3@2x.png 2x, {CDN_URL}/careers/3.png 1x', type: 'image/png' }]" ratio="5:2" alt="Abstract art image")

    .grid.is-desktop-4
      .column.u-mb-xs(v-for="item in $t('lifeItems')")
        h4 {{ item.title }}
        p {{ item.desc }}
    AppLink(to="/careers/perks" title="$t('lifeCta')" class="button-link " v-html="$t('lifeCta')")

  section.u-mt-md
    .grid.is-desktop-6
      .column.u-mb-sm
        AppCardBox
          h4 {{$t('workshops')}}
          p.u-mb-ts {{$t('workshopsDesc')}}
          AppLink(to="/workshops" title="$t('learnMore')" class="button-link is-small") {{$t('learnMore')}}
      .column.u-mb-sm
        AppCardBox
          h4 {{$t('internships')}}
          p.u-mb-ts {{$t('internshipsDesc')}}
          AppLink(to="/internships" title="$t('learnMore')" class="button-link is-small") {{$t('learnMore')}}

  AppSection(:img="[{ srcset: '{CDN_URL}/careers/4@2x.webp 2x, {CDN_URL}/careers/4.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/careers/4@2x.png 2x, {CDN_URL}/careers/4.png 1x', type: 'image/png' }]" ratio="5:3" :img-alt="$t('home')" class="u-mt-md ")
    h3 {{$t('home')}}
    p {{$t('homeDesc')}}


  section.u-mt-md
    AppTitle.u-mb-sm(:title="$t('insights')" tag="h2")

    .grid.is-tablet-6.is-desktop-4
      .column.u-mb-sm(v-for="item in $t('insightsItems')")
        p {{ item }}

    AppLink(to="/culture/manifesto" :title="$t('curious')" class="button-link is-medium ")  {{$t('curious')}}

  AppSection(:img="[{ srcset: '{CDN_URL}/academy@2x.webp 2x, {CDN_URL}/academy.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/academy@2x.png 2x, {CDN_URL}/academy.png 1x', type: 'image/png' }]" ratio="5:4" img-alt="Join us for the summer"  class="u-mt-md ")
    h3 {{$t('academy')}}
    p.u-mb-sm {{$t('academyDesc')}}
    AppLink(to="/academy" :title="$t('learnMore')" class="button-link is-medium ") {{$t('learnMore')}}

  section.u-mt-md
    h2.u-mb-mi {{$t('game')}}
    .grid.is-tablet-6.is-desktop-4
      .column.u-mb-sm(v-for="item in $t('gameItems')")
        p {{ item }}

  section.u-mt-md
    AppLink(to="/careers/journey" :title="$t('knowHow')" class="button-link") {{$t('knowHow')}}
  .u-mb-md
</template>

<script>
import { Careers } from '~/graphql/Career.gql';
import Query from '~/components/Query';
import AsymetricGrid from '~/components/PsudoRandomGrid';
import CareersCard from '~/components/CareersCard';

export default {
  scrollToTop: true,
  methods: {
    getBranchName(item) {
      return item.branchObj ? item.branchObj.name : '';
    }
  },
  head() {
    const $t = this.$t.bind(this);

    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: '{CDN_URL}/share/careers.jpg'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: '{CDN_URL}/share/careers.jpg'
        }
      ]
    };
  },
  components: {
    Query,
    AsymetricGrid,
    CareersCard
  },
  async asyncData({ app }) {
    const { data } = await app.$api.query({
      query: Careers,
      variables: {
        first: 4,
        isPublished: true,
        isArchived: false
      }
    });

    return { careers: data.careers };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat Careers",
    "pageDesc":"Developers, designers and strategists, check the opening positions and apply today to join Baianat family.",
    "mantra":"Looking for passionate |leaders.",
    "culture":"A culture of we.",
    "cultureDesc":"Great things are done by 'us' and ' we' not 'I' or 'mine'. And because we are proud to say 'ours', we credit teams not individuals. Because one man shows are boring and vim needs a group to be felt.",
    "baianaters":"Meet the Baianaters",
    "baianatersDesc":"We are believers, innovators and free souls. Together, we fight, make mistakes, learn, iterate and enjoy doing our best everyday with passion!",
    "baianatersCta":"Our teams",
    "values":"Our core |values.",
    "valuesItems":{
      "1":{
        "title":"Authenticity",
        "desc":"We pour our soul into everything we do and take pride of ourselves and visions. That’s why we create things in our own way and add unexpected twists to every project."
      },
      "2":{
        "title":"Credibility",
        "desc":"Walking the talk and talking the walk. We respect the trust our partners place in us and take the responsibility of meeting the impression created in their minds."
      },
      "3":{
        "title":"Transparency",
        "desc":"No secrets. No barriers. We work closely with our partners to create projects of value. When issues arise, we address it together and talk freely over anything and everything."
      }
    },
    "valuesCta":"See our values",
    "life":"Life inside |baianat.",
    "lifeItems":{
      "1":{
        "title":"Team gatherings",
        "desc":"Just as family gatherings, we get around the table on special occasions and birthdays to share stories and bond with each other on personal levels."
      },
      "2":{
        "title":"Learning trips",
        "desc":"From time to time, we travel as a team for sessions, meetups and conferences where we can engage with like minded professionals and exchange experiences."
      },
      "3":{
        "title":"New year welcoming",
        "desc":"At the beginning of every year, we set in a meeting to share our last year mistakes, achievements and turning points then promise ourselves with a killing one ahead."
      }
    },
    "lifeCta":"Discover the perks of <br> being a Baianater",
    "home":"Our home.",
    "homeDesc":"Since we spend more time together than with our families, we decorated the place in our way and added our personalities around every corner for a cozy atmosphere that feels just like home.",
    "homeCta":"Meet the teams",
    "insights":"Insights we |live by.",
    "insightsItems":{
      "1":"One who has no morals, has no knowledge.",
      "2":"'Time is gold' doesn't describe the importance of time accurately.",
      "3":"Success is not about luck, it's about sacrifice.",
      "4":"For every problem there is a solution and an IDEAL solution.",
      "5":"The necktie suffocate only the one who wears it.",
      "6":"Problems are not stop signs, but they are guidelines."
    },
    "curious":"Curious for more?",
    "academy":"Academy.",
    "academyDesc":"Start your career ahead and be part of Baianat team during the summer. Apply to join our internship program in business, design, code and technology.",
    "game":"Game rules.",
    "gameItems":{
      "1":"Love what you do and do it with love.",
      "2":"Stop watching your clock and start observing your progress.",
      "3":"Behaviors are valued over technicality.",
      "4":"Act as a family member, not an employee.",
      "5":"Read tons of books to solve millions of problems.",
      "6":"Adopt a lean mentality."
    },
    "featuredPositions":"Featured positions",
    "knowHow":"Know how we hire",
    "workshops":"Workshops",
    "workshopsDesc":"Have an intense learning experience about the topics of your interest.",
    "internships":"Internships",
    "internshipsDesc":"Join us for a longer duration and build up your career path earlier.",
    "cta":"See opportunities"
  },
  "ar": {
    "pageTitle":"وظائف بيانات",
    "pageDesc":"سواء كنت من المبرمجين أو المصممين أو الاستراتيجيين تفحص المواقع المتاحة لدينا وانضم إلى أسرة بيانات وكن فرد من العائلة.",
    "mantra":"نبحث عن |قادة. ",
    "culture":"مفهوم الـ معًا.",
    "cultureDesc":"تنشأ الأمور العظيمة من خلال 'نحن' وليس ' أنا'. ولأننا نفخر بقول ' لنا'، تجدنا نهتم بتكوين فرق لا أفراد. فالعرض المنفرد أصبح مملًا والهِمة تحتاج إلى احساس المجموعة.",
    "baianaters":"تقابل مع Baianaters.",
    "baianatersDesc":"نمتلك الثقة والروح الحرة التي تجعلنا نبتكر. معًا، نبحث ونتعلم ونفكر ونستمتع بتقديم أفضل ما لدينا كل يوم بشغف.",
    "baianatersCta":"الفريق",
    "values":"قيمنا |الأساسية.",
    "valuesItems":{
      "1":{
        "title":"الأصالة",
        "desc":"تنغمس أرواحنا في كل شيء نقوم به. نفخر بأنفسنا و بالرؤى الخاصة بنا. لهذا نصنع الأشياء على طريقتنا الخاصة، و نضيف إليها ما هو غير متوقع في كل مرة."
      },
      "2":{
        "title":"المصداقية",
        "desc":"أفعالنا هي ما تتحدث عنا. نحترم الثقة التي وضعها شركاء النجاح فينا، ونتحمل مسؤولية تلبية الانطباع الذي تكون في أذهانهم عنا."
      },
      "3":{
        "title":"الشفافية",
        "desc":"ليس لدينا أسرار أو حواجز، نعمل عن قرب مع شركاء النجاح لإنشاء مشروعات ذات قيمة. عندما تظهر أى مشكلة، نتناولها سويًا ونتحدث بحرية حول أي شيء وكل شيء."
      }
    },
    "valuesCta":"تعرف على قيمنا",
    "life":"الحياة داخل |بيانات.",
    "lifeItems":{
      "1":{
        "title":"تجمُعات الفريق",
        "desc":"تمامًا مثل التجمعات العائلية، نتقابل حول طاولة واحدة في المناسبات الخاصة وأعياد الميلاد لمشاركة قصصنا؛ لنرتبط ببعضنا أكثر وأكثر على المستوى الشخصي."
      },
      "2":{
        "title":"رحلات التعلُم",
        "desc":"من وقت لآخر، نسافر سويًا لحضور الاجتماعات والمحاضرات والمؤتمرات، حيث يمكننا التواصل وتبادل الخبرات مع المهنيين الذين يمتلكون نفس تفكيرنا وشغفنا."
      },
      "3":{
        "title":"الترحيب بالعام الجديد.",
        "desc":"في بداية كل عام، نجتمع معًا لمشاركة الانجازات التي حققناها، والاعتراف بالأخطاء التي وقعنا فيها، ونوعد أنفسنا بتحقيق المزيد في العام الجديد."
      }
    },
    "lifeCta":"اكتشف الامتيازات التي ستحصل <br> عليها كونك جزء من الفريق",
    "home":"بيانات منزلنا",
    "homeDesc":"لأننا نقضي أكثر الوقت سويًا ربما أكثر مما نقضيه مع عائلتنا، لهذا قُمنا بتزيين المكان على طريقتنا الخاصة، فكل فرد منا يضيف لمسته على المكان ليصبح بالنسبة إليه مريحًا تمامًا كمنزله.",
    "homeCta":"تقابل مع الفريق",
    "insights":"الرؤى التي نسير |عليها.",
    "insightsItems":{
      "1":"لا علم لمْن لا أخلاق له.",
      "2":"النجاح لا يأتي صدفة، بل نتيجة تعب ومجهود مضني.",
      "3":"الوقت كالسيف وصف لا يعبر بمصداقية عن مدى أهمية الوقت.",
      "4":"هناك مشكلة، إذن هناك دائما حل، وحل أمثل.",
      "5":"ربطة العنق لا تخنق إلا عنق مْن يرتديها فقط.",
      "6":"المشاكل ليست علامات وقوف، لكنها خطوط إرشادية."
    },
    "curious":"شغوف بأكثر من ذلك؟!",
    "academy":"الأكاديمية",
    "academyDesc":"ابدأ مسيرتك مبكرًا وكُن جزءًا من فريق بيانات خلال فصل الصيف. تقدم للانضمام إلى التدريب الداخلي لدينا في الأعمال التجارية أو التصميم أو البرمجة و التكنولوجيا.",
    "game":"قواعد اللعبة",
    "gameItems":{
      "1":"حب ما تفعله وافعله بشغف.",
      "2":"توقف عن النظر إلى ساعتك وابدأ في مراقبة تقدمك.",
      "3":"القيم تفوق المهارات التقنية.",
      "4":"تصرف كأحد أفراد العائلة وليس كموظفًا.",
      "5":"اقرأ أطنان الكتب لتحل ملايين المشكلات.",
      "6":"اعتمد على التفكير المرن."
    },
    "featuredPositions":"فرص الوظائف.",
    "knowHow":"كيف تنضم إلى أسرة بيانات؟!",
    "workshops":"ورش العمل",
    "workshopsDesc":"تمتع  بتجربة تعليمية مكثفة حول الموضوعات التي تهمك.",
    "internships":"التدريب الداخلي",
    "internshipsDesc":"انضم إلينا لفترة أطول وقم ببناء مسار حياتك المهنية في وقت مبكر.",
    "cta":"تعرف على الفرص المتاحة"
  }
}
</i18n>
